<script setup>
defineProps({
  steps: { type: Array, required: true },
  current: { type: String, required: true },
})
</script>

<template>
  <nav :aria-label="$t('ux.workflowProgress')" class="px-4 py-3">
    <ol class="flex flex-wrap gap-x-4 gap-y-2 text-sm">
      <li v-for="(step, index) in steps" :key="step.id"
        :aria-current="current === step.id ? 'step' : undefined"
        :class="current === step.id ? 'font-bold text-[var(--color-accent)] underline underline-offset-4' : 'text-[var(--color-muted)]'">
        <span aria-hidden="true">{{ index + 1 }}. </span>{{ step.label }}
      </li>
    </ol>
  </nav>
</template>
